import { CATEGORIES, CATEGORY_LABELS } from "@/constants/categories";

// Kategorie-Ring Komponente für Fortschritt - MIT MEILENSTEIN-LOGIK
const CategoryRing = ({ category, count, total, language, onClick }) => {
  const config = CATEGORIES[category] || CATEGORIES.herz;
  const Icon = config.icon;
  const hasProgress = count > 0;
  
  // Progressive Meilensteine: 7 → 30 → 100
  const getMilestone = (currentCount) => {
    if (currentCount < 7) return { current: 0, target: 7, prevTarget: 0 };
    if (currentCount < 30) return { current: 7, target: 30, prevTarget: 7 };
    if (currentCount < 100) return { current: 30, target: 100, prevTarget: 30 };
    return { current: 100, target: 100, prevTarget: 100 }; // Max erreicht
  };
  
  const milestone = getMilestone(count);
  const progressInMilestone = count - milestone.prevTarget;
  const milestoneRange = milestone.target - milestone.prevTarget;
  const percentage = milestone.target === 100 && count >= 100 
    ? 100 
    : Math.min((progressInMilestone / milestoneRange) * 100, 100);
  
  const circumference = 2 * Math.PI * 20; // radius = 20
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  
  // Display: zeige count/target
  const displayCount = count;
  const displayTarget = milestone.target;
  
  return (
    <button 
      className={`category-ring ${hasProgress ? 'active' : 'inactive'}`}
      onClick={onClick}
      data-testid={`category-ring-${category}`}
      style={{ '--category-color': config.color, '--category-bg': config.colorMuted }}
    >
      {/* Ring Container mit SVG */}
      <div className={`ring-container ${hasProgress ? 'has-progress pulse-glow' : ''}`} style={{ '--category-color': config.color }}>
        <svg className="ring-svg" viewBox="0 0 48 48">
          {/* Background circle */}
          <circle
            cx="24"
            cy="24"
            r="20"
            fill="none"
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="3"
          />
          {/* Progress circle */}
          <circle
            cx="24"
            cy="24"
            r="20"
            fill="none"
            stroke={config.color}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className={hasProgress ? 'progress-ring-active' : ''}
            style={{ 
              transform: 'rotate(-90deg)',
              transformOrigin: 'center',
              transition: 'stroke-dashoffset 0.5s ease-out'
            }}
          />
        </svg>
        <div className={`ring-icon ${hasProgress ? 'active' : ''}`}>
          <Icon 
            size={20}
            style={{ 
              color: hasProgress ? config.color : 'rgba(255,255,255,0.5)',
              transition: 'all 0.3s ease'
            }} 
          />
        </div>
      </div>
      
      {/* Count & Label - Meilenstein-Anzeige */}
      <div className="ring-info">
        <span className={`ring-count ${hasProgress ? 'active' : ''}`}>
          {displayCount}/{displayTarget}
        </span>
        <span className="ring-label">
          {CATEGORY_LABELS[category]?.[language] || CATEGORY_LABELS[category]?.en}
        </span>
      </div>
    </button>
  );
};

export default CategoryRing;
